import axios from "axios";
import { host } from "./utilities";

axios.defaults.withCredentials = true;
export const cashServiceUserPrincipleAxios = () => (config) => axios.get(`${host()}/user`, config);
export const cashServiceUserRolesAxios = () => (config) => axios.get(`${host()}/user/roles`, config);
